"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
var _default = exports.default = {
  getList: function getList(data, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/app_version/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getDetail: function getDetail(id) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/app_version/query/' + id,
      method: 'get'
    });
  },
  saveItem: function saveItem(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/app_version/save',
      method: 'post',
      data: data
    });
  },
  releaseApp: function releaseApp(id) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/app_version/release_app_version/' + id,
      method: 'get'
    });
  },
  saveItem2: function saveItem2(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/support/update/appVersion?version=V' + data.displayVersion,
      method: 'post'
    });
  },
  getHisList: function getHisList(id) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/app_version/app_version_his/' + id,
      method: 'get'
    });
  },
  clearUserCache: function clearUserCache() {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/support/delete/onlineUser',
      method: 'post'
    });
  }
};